import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/">
            <Logo />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="/#tools" className="text-sm text-gray-600 hover:text-brand-600 transition-colors">Tools</a>
            <Link to="/blog" className="text-sm text-gray-600 hover:text-brand-600 transition-colors">Blog</Link>
            <Link to="/about" className="text-sm text-gray-600 hover:text-brand-600 transition-colors">About</Link>
            <Link to="/support" className="text-sm text-gray-600 hover:text-brand-600 transition-colors">Support</Link>
          </div>

          <button
            className="md:hidden p-2 text-gray-600"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 px-4 pb-4">
          <a href="/#tools" className="block py-2 text-sm text-gray-600 hover:text-brand-600">Tools</a>
          <Link to="/blog" className="block py-2 text-sm text-gray-600 hover:text-brand-600" onClick={() => setMobileOpen(false)}>Blog</Link>
          <Link to="/about" className="block py-2 text-sm text-gray-600 hover:text-brand-600" onClick={() => setMobileOpen(false)}>About</Link>
          <Link to="/support" className="block py-2 text-sm text-gray-600 hover:text-brand-600" onClick={() => setMobileOpen(false)}>Support</Link>
        </div>
      )}
    </nav>
  );
}
